export default __webpack_public_path__ + "static/media/gallery06.87561aab.png";